import { IonButton, IonIcon, IonItem, IonLabel } from '@ionic/react';
import { pencilSharp } from 'ionicons/icons';
import * as React from 'react';

import type { DeliveryAddress } from '@biteinc/core-react';
import { LocalizationHelper, TimeHelper } from '@biteinc/core-react';
import type { FulfillmentMethod } from '@biteinc/enums';
import { Strings } from '@biteinc/localization';

import { useLocalize } from '~/app/js/localization/localization';
import { useLocation } from '~/stores';

import { GcnFulfillmentHelper } from '../helpers';

interface FulfillmentMethodInfoProps {
  fulfillmentMethod: FulfillmentMethod;
  pickupAtIso?: string;
  enableItemClick?: boolean;
  deliveryAddress?: DeliveryAddress;
  onEdit: () => void;
}

export function FulfillmentMethodInfo(props: FulfillmentMethodInfoProps): React.ReactElement {
  const { deliveryAddress, fulfillmentMethod } = props;
  const str = useLocalize();
  const location = useLocation();
  const address = GcnFulfillmentHelper.addressAsMultipleLines(deliveryAddress);
  const diningOption = location.getDiningOptionForFulfillmentMethod(fulfillmentMethod);
  const diningOptionName =
    diningOption.name ?? str(LocalizationHelper.localizeEnum.FulfillmentMethod(fulfillmentMethod));

  const orderTimeDescription = TimeHelper.getFriendlyFutureTimeDescription(props.pickupAtIso);
  const localizedOrderTimeDescription = orderTimeDescription ?? str(Strings.ASAP);
  const pickupTimeLabel =
    diningOption.futureOrdersEnabled && (props.pickupAtIso || diningOption.asapOrdersEnabled)
      ? localizedOrderTimeDescription
      : undefined;

  return (
    <IonItem
      lines="none"
      className="edit-fulfillment-method"
      onClick={() => {
        if (props.enableItemClick) {
          props.onEdit();
        }
      }}
    >
      <IonLabel className="change-fulfillment-text">
        <span className="fulfillment-method-label">
          {diningOptionName}
          {deliveryAddress ? (
            <span className="delivery-address">{`\u00a0to\u00a0${address}`}</span>
          ) : null}
        </span>
        {pickupTimeLabel ? <span className="pickup-time"> {pickupTimeLabel}</span> : null}
      </IonLabel>
      <IonButton
        className="edit-fulfillment-method-button"
        fill="clear"
        onClick={() => {
          props.onEdit();
        }}
      >
        {gcn.org.orgCode ? (
          <IonIcon
            aria-hidden="true"
            className="edit-fulfillment-method-icon"
            icon={pencilSharp}
            slot="start"
          />
        ) : null}
        Edit
      </IonButton>
    </IonItem>
  );
}
